import React, { useState, useEffect } from 'react';
import Razorpay from 'razorpay';
import axios from 'axios';

import './webprofile.css';
import {
  BrowserRouter as Router,
  Link,
  Route,
  Routes,
  useParams,
} from "react-router-dom";
const Payment = () => {
  const [amount, setAmount] = useState('');
  const [paymentstatus,setpaymentstatus]=useState('')
  const [paymenttext,setpaymenttext]=useState('Pay with Razorpay')
  
  const { id } = useParams();
  const month=id.split('_')[1]
  useEffect(() => {
    paymentfunction()
      ;
    }, []);
    const showLoader = () => {
      return (
        <div className="bouncing-ball">
          
        
        <div className="bouncing-ball">
          
          </div>
        </div>
      );
    };
 const paymentfunction = async () => {
   /* const result = await axios.post('https://us-central1-jiffybook-india.cloudfunctions.net/razorpaycreateOrder', 
        {
      amount: amount,
      currency: 'INR', // Or any currency supported by Razorpay
    });*/
    console.log('posting',amount)
  const result = //await fetch(`https://us-central1-jiffybook-india.cloudfunctions.net/RazorpaycreaterouteOrder?parameter=${id}`)
   await axios({
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        url:` https://us-central1-jiffybook-india.cloudfunctions.net/RazorpaycreateInvoiceOrder?parameter=${id}`, 
       
       data:{
        amount: amount,
        currency: 'INR',

        },
      
      })
        
      console.log('resultfetched',result.data)
      setpaymentstatus(result.data.strStatus)
      //console.log('paymentdata',paymentdata)
  /*  const options = {
      key: 'rzp_test_VxUM6IGnSiuawY',
      amount: amount * 100, // Razorpay accepts amount in paise
      currency: 'INR',
      name: 'Your App Name',
      description: 'Test Transaction',
      order_id: orderId,
      handler: function (response) {
        // Handle the success response here
        console.log(response);
        alert('Payment Successful');
      },
      prefill: {
        name: 'Your Name',
        email: 'mak@indreamer.com',
        contact: '9999999999',
      },
      theme: {
        color: '#3399cc',
      },
    };*/
    if(result.data.strStatus!='Paid'){
      
    var options1 = {
      key_id:'rzp_live_lSWBEiq0m9HpVi',
     // key_id: process.env.REACT_APP_RAZORPAY_TESTKEY,
      "key": 'rzp_live_lSWBEiq0m9HpVi',//process.env.REACT_APP_RAZORPAY_TESTKEY, // Enter the Key ID generated from the Dashboard
     // "key": process.env.REACT_APP_RAZORPAY_TESTKEY,
      "amount": result.data.amount*100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      "currency": "INR",
      "name": result.data.strBname, //your business name
      "description": "Test Transaction",
     // "image": "https://firebasestorage.googleapis.com/v0/b/jiffybook-india.appspot.com/o/dbbusiness%2FWOhZQKZUEUQm6a0nhPUa%2FLogo%2Fairinabayawomenscollection.png?alt=media&token=bd1392c9-8b53-4205-9640-b696d1dc3a15",
      "order_id": result.data.orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
     // "callback_url": "https://eneqd3r9zrjok.x.pipedream.net/",
      "prefill": { //We recommend using the prefill parameter to auto-fill customer's contact information especially their phone number
          "name": result.data.strCname, //your customer's name
          "email": result.data.strCmail,
          "contact": "9000090000" //Provide the customer's phone number for better conversion rates 
      },
      "notes": {
          "address": "Indreamer Corporate Office"
      },
      handler: async function (response) {
        // Send payment details to Cloud Function
        
        try {
         /* const result = await axios.post('YOUR_CLOUD_FUNCTION_URL', {
            paymentId: response.razorpay_payment_id,
            orderId: response.razorpay_order_id,
            signature: response.razorpay_signature,
          });*/
          
          setpaymentstatus('')
          console.log('paymentstatus',response)
          await axios({
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url:`https://us-central1-jiffybook-india.cloudfunctions.net/verifyAndSaveInvoicePayment`, 
           
           data:{
            paymentid:response.razorpay_payment_id,
            orderid:response.razorpay_order_id,
            signature:response.razorpay_signature,
        strBID:result.data.strBID,
        Month:month,
        /*strBname:result.data.strBname,
        strCmail:result.data.strCmail,
        strCname:result.data.strCname,
        strCurrency:result.data.strCurrency,
        strExtRef :response.razorpay_signature,
        strRCID:result.data.strRCID,
       // strStatus :response.paymentstatus,
        strTcode:result.data.strTcode,*/
            },
          
          })
          console.log('Payment verified and saved:', response
          );
          setpaymentstatus('Paid')
        } catch (error) {
          console.error('Error verifying payment:', error);
        }
      },
     
      "theme": {
          "color": "#3399cc"
      }
  };
  const rzp = new window.Razorpay(options1);
    rzp.open();
    rzp.on('payment.failed', function (response){
      setpaymentstatus('Unpaid')
      setpaymenttext('Payment failed')
  /*    alert(response.error.code);
      alert(response.error.description);
      alert(response.error.source);
      alert(response.error.step);
      alert(response.error.reason);
      alert(response.error.metadata.order_id);
      alert(response.error.metadata.payment_id);*/
      console.log('failed',response.error)
});}
else{
  console.log('Paid already')
}
  };

  return (
    <div>
      {paymentstatus==''?(
      <div style={{marginLeft:'48%',marginTop:50}} className="bouncing-ball">
       {showLoader()}
    </div>):null}
      {paymentstatus!='Paid'?(
      <h2 style={{textAlign:'center'}}>{paymenttext}</h2>
      ):
      <h2 style={{textAlign:'center'}}>Payment completed</h2>
}
    </div>
  );
};

export default Payment;
